// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
import { ChartMath } from '../Utils/ChartMath';
import { CurveToolView } from './CurveToolView';
export class CircleToolView extends CurveToolView {
    Draw(gr, ww, param) {
        const lastCurvePoints = this.lastCurvePoints;
        if (!lastCurvePoints)
            return;
        const dataCacheTool = this.dataCacheTool;
        const fill = dataCacheTool.fill;
        const fillBrush = dataCacheTool.FillBrush;
        const pen = dataCacheTool.Pen;
        //
        // блок для сброса искажения. рисеут эллипс каким он станет в случае сброса масштаба, в случае смещения точки
        // выделена точка, рисуем контур модифая!
        if (this.CurrentSelection.SelectedPointNo >= 0) {
            let centerX, centerY, circleX, circleY, radius;
            const res = this.GetVariables(centerX, centerY, circleX, circleY, radius);
            centerX = res.centerX;
            centerY = res.centerY;
            circleX = res.circleX;
            circleY = res.circleY;
            radius = res.radius;
            const pX = centerX - radius;
            const pY = centerY - radius;
            const diameter = radius * 2;
            if (fill) {
                gr.FillEllipse(fillBrush, pX, pY, diameter, diameter);
            }
            gr.DrawEllipse(pen, pX, pY, diameter, diameter);
            super.Draw(gr, ww, param);
        }
        if (lastCurvePoints.length > 2) {
            // Ловим ошибки
            /*
        if (lastCurvePoints[0].X >= ProMath.infinity || lastCurvePoints[0].Y >= ProMath.infinity || lastCurvePoints[0].X <= ProMath.infinityMinus || lastCurvePoints[0].Y <= ProMath.infinityMinus)
        { }
        else */
            // {
            // рисуем эллипс по точкам
            gr.DrawClosedCurve(pen, lastCurvePoints);
            if (fill) {
                gr.FillClosedCurve(fillBrush, lastCurvePoints);
            }
            // }
        }
        super.Draw(gr, ww, param);
    }
    UpdateAdditionalPoints(ww, movePointNo, cashItemSeries) {
        // только 2 базовые точки
        this.UpdateScreenPointsALL(ww, cashItemSeries, true);
        const newPts = this.getCirclePoints(ww, cashItemSeries);
        const newPts_len = newPts.length;
        const dataCacheTool = this.dataCacheTool;
        const temp = dataCacheTool.CopyPoints();
        for (let i = 0; i < newPts_len; i++) {
            temp[2 + i] = newPts[i];
        }
        dataCacheTool.Points = temp;
    }
    getCirclePoints(ww, cashItemSeries) {
        const dataCacheTool = this.dataCacheTool;
        const pc = ww.PointsConverter;
        const newAddPoints = [];
        let centerX, centerY, circleX, circleY, radius;
        const res = this.GetVariables(centerX, centerY, circleX, circleY, radius);
        centerX = res.centerX;
        centerY = res.centerY;
        circleX = res.circleX;
        circleY = res.circleY;
        radius = res.radius;
        if (!radius)
            return newAddPoints;
        /// !!! Будем рисовать эллипс по точкам. точек будем искать много чтоб не страдала точность прорисовки кривой по точкам.
        /// http://stackoverflow.com/questions/4467121/solutions-for-y-for-a-rotated-ellipse
        /// уравнение эллипса  x = a*cos(t)*cos(w) - b*sin(t)*sin(w),  y = a*cos(t)*sin(w) + b*sin(t)*cos(w)
        /// где а и b - большая и меньшая оси эллипса соответственно,
        /// w - угол поворота эллипса, t - направление на точку в полярных координатах
        /// х0 и у0 - центр эллипса.
        ///
        const w = 0;
        const a = radius;
        let t = 0;
        const b = radius;
        const incr = 6.28 / dataCacheTool.AdditionalPointsCount();
        for (t = 0; t < 6.28; t += incr) {
            // fix 6,28 чтоб точки не накладывались в петельку
            const xt = a * Math.cos(t) * Math.cos(w) - b * Math.sin(t) * Math.sin(w);
            const yt = b * Math.cos(w) * Math.sin(t) + a * Math.cos(t) * Math.sin(w);
            newAddPoints.push(this.ConvertPoints(xt + centerX, centerY + yt, pc, cashItemSeries === null || cashItemSeries === void 0 ? void 0 : cashItemSeries.settings));
        }
        return newAddPoints;
    }
    DrawSelectedLine(gr, ww, x1, y1, x2, y2) {
        gr.DrawLine(this.dataCacheTool.Pen, x1, y1, x2, y2);
        super.DrawSelectedLine(gr, ww, x1, y1, x2, y2);
    }
    GetVariables(centerX, centerY, circleX, circleY, radius) {
        const screenPoints = this.screenPoints;
        const scrP0 = screenPoints[0];
        const scrP1 = screenPoints[1];
        centerX = scrP0[0];
        centerY = scrP0[1];
        circleX = scrP1[0];
        circleY = scrP1[1];
        radius = ChartMath.CalcDistanceFromPointToPoint(new Point(centerX, centerY), new Point(circleX, circleY));
        return {
            centerX,
            centerY,
            circleX,
            circleY,
            radius
        };
    }
}
